import { render, staticRenderFns } from "./IconMessageQuestion.vue?vue&type=template&id=3fc0af4c"
import script from "./IconMessageQuestion.vue?vue&type=script&lang=js"
export * from "./IconMessageQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports